import { Container, Link, Stack, Text } from "basis";
import { CreditCard } from "components/CreditCard/CreditCard";
import { SvgInline } from "../../SvgInline/SvgInline";
import { ScreenProps } from "../reducer/types";

export const JointAccount = ({
  state: { accountInfo, personalDetails },
}: ScreenProps) => (
  <Stack gap="8">
    <Container bg="grey.t05" padding="4">
      <CreditCard
        cardName={accountInfo.cardName}
        cardEndsWith={accountInfo.cardEndsWith}
      />
    </Container>
    <SvgInline name="statement-preference" size="92" />
    <Text as="h4" textStyle="heading4">
      Statement preference
    </Text>
    <Text>
      Due to the status of your account, this service is currently not
      available. Please give us a call if you require further information.
    </Text>
    <Link
      appearance="primary-button"
      variant="blue-button"
      width="216"
      href="/manage-account"
      newTab={false}
    >
      Manage account
    </Link>
  </Stack>
);
